import styled from '@emotion/styled';
import { colors } from '@libs/ui';

/** ヘッダーに並べるボタンを 1 つの枠に収める。ボタンの間は {@link HeaderControlGroupDivider} で区切る。 */
const HeaderControlGroup = styled.div`
  display: inline-flex;
  align-items: center;
  height: 25px;
  margin-top: 7px;
  border: 1px solid ${colors.deepGray};
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  color: ${colors.txtBlack};
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
`;

const HeaderControlGroupDivider = styled.span`
  align-self: stretch;
  width: 1px;
  flex-shrink: 0;
  background-color: ${colors.deepGray};
`;

/** {@link HeaderControlGroup} に収めるボタンの共通の見た目。 */
const HeaderControlGroupItem = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 100%;
  border: none;
  box-sizing: border-box;
  background-color: transparent;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  cursor: pointer;

  &:hover {
    background-color: ${colors.white};
  }
`;

export { HeaderControlGroup, HeaderControlGroupDivider, HeaderControlGroupItem };
